import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { API_PDP_ACTION_STEP_COMPLETION } from 'constants/api';
import { generateURL } from 'helpers';

export const updateActionStepCompletion = createAsyncThunk<
  void,
  { id: number; actionStepId: number; isAchieved: boolean }
>(
  'pdp/updateActionStepCompletion',
  async ({ id, actionStepId, isAchieved }, { rejectWithValue }) =>
    api.axios
      .patch(
        generateURL(API_PDP_ACTION_STEP_COMPLETION, { id, actionStepId }),
        { actionStepId, isAchieved },
      )
      .then(() => undefined)
      .catch((e) => rejectWithValue(e.response?.data)),
);
